module.exports = {
    // basic
    'current-password': 'contraseña actual',
    'new-password': 'nueva contraseña',

    // raw
    // template
};
